import {useState} from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@/contents/components/ButtonComp';
import React from 'react';
import {styled} from "@mui/material/styles";

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryStateType {
  error: boolean,
  errorMsg: string,
  showErrorMsgCnt: number,
}

const ErrorBoundary = ({children}: ErrorBoundaryProps) => {
  const [state, setState] = useState<ErrorBoundaryStateType>({
    error: false,
    errorMsg: '',
    showErrorMsgCnt: 0,
  });

  const refresh = () => {
    window.location.reload();
  }

  const goBack = () => {
    setState({
      error: false,
      errorMsg: '',
      showErrorMsgCnt: 0,
    });
  }

  const plusShowErrorMsgCnt = () => {
    setState({
      ...state,
      showErrorMsgCnt: state.showErrorMsgCnt + 1,
    });
  }

  return (
      <>
        {state.error &&
            <ErrorComponent
                showErrorMsgCnt={state.showErrorMsgCnt}
                errorMsg={state.errorMsg}
                plusShowErrorMsgCnt={plusShowErrorMsgCnt}
                goBack={goBack.bind(this)}
                refresh={refresh.bind(this)}
            />
        }
        {children}
      </>
  );
}

interface ErrorComponentProps {
  refresh: () => void
  goBack: () => void
  plusShowErrorMsgCnt: () => void
  showErrorMsgCnt: number
  errorMsg: string
}

const ErrorComponent = ({ refresh, goBack, plusShowErrorMsgCnt, showErrorMsgCnt, errorMsg }: ErrorComponentProps) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
    goBack();
  };

  return (
    <Error>
      <span className="comment-service-not">
        <span onClick={() => plusShowErrorMsgCnt()}>서비스</span>에 접속할 수 없습니다.
      </span>
      <span className="comment-sorry">
        페이지를 로드하는 도중에 오류가 발생하였습니다.
        <br />
        서비스 이용에 불편을 드려 죄송합니다.
      </span>
      <div className="error-msg">{showErrorMsgCnt > 20 && errorMsg}</div>
      <div className="button-area">
        <StyledButton color="black" outline onClick={() => handleGoBack()}>
          뒤로가기
        </StyledButton>
        <StyledButton color="black" onClick={() => refresh()}>
          새로고침
        </StyledButton>
      </div>
    </Error>
  );
};

const Error = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  font-size: 40px;

  .comment-service-not {
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    color: #000000;
  }

  .comment-sorry {
    font-weight: normal;
    margin-top: 20px;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #000000;
  }

  .error-msg {
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #000000;
  }

  .button-area {
    margin-top: 30px;
  }
`;

const StyledButton = styled(Button)`
  font-size: 16px;
  line-height: 20px;

  & + & {
    margin-left: 20px;
  }
`;

export default ErrorBoundary;
